'use client';

import Image from 'next/image';

import { styles } from './RoundedBanner.styles';

export interface RoundedBannerProps {
  image: string;
  text: string;
}

export function RoundedBanner({ image, text }: RoundedBannerProps) {
  const slots = styles();

  if (!image || !text) {
    return null;
  }

  return (
    <div className={slots.base()}>
      <Image
        src={image}
        alt="Rounded Banner"
        width={500}
        height={500}
        className={slots.image()}
      />
      <div
        className={slots.content()}
        dangerouslySetInnerHTML={{ __html: text }}
      ></div>
    </div>
  );
}
